var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isMobile ? 'container mobile ' : 'container',attrs:{"id":"app"}},[_c('keep-alive',[_c('router-view')],1),(_vm.isMobile)?_c('My-mobilFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }